<app-perfil-shell [showGreeting]="false" [showSecurityBanner]="false" [skipFooterCms]="true" [sectionViewport]="true">
  <div class="perfil-section-page">
    <div class="perfil-section-page__chrome">
      <app-perfil-steps-strip activa="sobre-ti"></app-perfil-steps-strip>
    </div>

    <div class="perfil-section-page__scroll" #sectionScroll (scroll)="hideFechaCamaraHint()">
      <div class="perfil-section-page__scroll-inner">
        <form class="perfil-section-page__panel perfil-section-page__panel--flat" [formGroup]="form"
          (ngSubmit)="onCta()">

          @if (esJuridica) {
          @if (currentStepId === 'datos-empresa') {
          <div class="perfil-section-page__grid" id="perfil-sobre-ti-datos">
            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('genero')">
              <label class="perfil-field__label" for="genero">{{ copy.sobreEmpresa.campos.genero }}</label>
              <select id="genero" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona género"
                formControlName="genero" (change)="onSelectpickerChange('genero')"
                [class.perfil-field__control--invalid]="isInvalid('genero')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreEmpresa.placeholderSelect }}</option>
                @for (opt of generos; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('genero')) {
              <p class="perfil-field__error">{{ errorMessage('genero') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('minoria')">
              <span class="perfil-field__label" id="lbl-minoria">{{ copy.sobreEmpresa.campos.minoria }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-minoria">
                <label class="perfil-radio">
                  <input type="radio" formControlName="minoria" value="si" />
                  <span>{{ copy.sobreEmpresa.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="minoria" value="no" />
                  <span>{{ copy.sobreEmpresa.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('minoria')) {
              <p class="perfil-field__error">{{ errorMessage('minoria') }}</p>
              }
            </div>

            @if (muestraMinoriaDescripcion) {
            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('minoriaDescripcion')">
              <label class="perfil-field__label" for="minoriaDescripcion">{{
                copy.sobreEmpresa.campos.minoriaDescripcion
                }}</label>
              <input id="minoriaDescripcion" class="perfil-field__control" type="text"
                formControlName="minoriaDescripcion" [placeholder]="copy.sobreEmpresa.placeholderTexto"
                [class.perfil-field__control--invalid]="isInvalid('minoriaDescripcion')" />
              @if (isInvalid('minoriaDescripcion')) {
              <p class="perfil-field__error">{{ errorMessage('minoriaDescripcion') }}</p>
              }
            </div>
            }

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('creditoFormal')">
              <span class="perfil-field__label" id="lbl-credito-pj">{{
                copy.sobreEmpresa.campos.creditoFormal
                }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-credito-pj">
                <label class="perfil-radio">
                  <input type="radio" formControlName="creditoFormal" value="si" />
                  <span>{{ copy.sobreEmpresa.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="creditoFormal" value="no" />
                  <span>{{ copy.sobreEmpresa.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('creditoFormal')) {
              <p class="perfil-field__error">{{ errorMessage('creditoFormal') }}</p>
              }
            </div>

            @if (muestraFechaDesembolso) {
            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('fechaDesembolso')">
              <label class="perfil-field__label" for="fechaDesembolso">{{
                copy.sobreEmpresa.campos.fechaDesembolso
                }}</label>
              <input id="fechaDesembolso" class="perfil-field__control" type="date" [attr.max]="fechaDesembolsoMax"
                min="1900-01-01" formControlName="fechaDesembolso"
                [class.perfil-field__control--invalid]="isInvalid('fechaDesembolso')" />
              @if (isInvalid('fechaDesembolso')) {
              <p class="perfil-field__error">{{ errorMessage('fechaDesembolso') }}</p>
              }
            </div>
            }

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('razonSocial')">
              <label class="perfil-field__label" for="razonSocial">{{
                copy.sobreEmpresa.campos.razonSocial
                }}</label>
              <input id="razonSocial" class="perfil-field__control" type="text" formControlName="razonSocial"
                [placeholder]="copy.sobreEmpresa.placeholderTexto"
                [class.perfil-field__control--invalid]="isInvalid('razonSocial')" />
              @if (isInvalid('razonSocial')) {
              <p class="perfil-field__error">{{ errorMessage('razonSocial') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required perfil-field--span-2"
              [class.perfil-field--invalid]="isInvalid('actividadEconomica')">
              <label class="perfil-field__label" for="actividadEconomica">{{
                copy.sobreEmpresa.campos.actividadEconomica
                }}</label>
              <select id="actividadEconomica" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona actividad económica"
                formControlName="actividadEconomica" (change)="onActividadEconomicaChange()"
                [class.perfil-field__control--invalid]="isInvalid('actividadEconomica')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreEmpresa.placeholderSelect }}</option>
                @for (opt of ciius; track opt.codigoCiiu) {
                <option [value]="opt.codigoCiiu" [attr.data-tokens]="opt.codigoCiiu">
                  {{ opt.codigoCiiu }} - {{ opt.nombreCiiu }}
                </option>
                }
              </select>
              @if (isInvalid('actividadEconomica')) {
              <p class="perfil-field__error">{{ errorMessage('actividadEconomica') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('tieneCamaraComercio')">
              <span class="perfil-field__label" id="lbl-tiene-camara">{{
                copy.sobreEmpresa.campos.tieneCamaraComercio
                }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-tiene-camara">
                <label class="perfil-radio">
                  <input type="radio" formControlName="tieneCamaraComercio" value="si" />
                  <span>{{ copy.sobreEmpresa.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="tieneCamaraComercio" value="no" />
                  <span>{{ copy.sobreEmpresa.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('tieneCamaraComercio')) {
              <p class="perfil-field__error">{{ errorMessage('tieneCamaraComercio') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--hidden]="!muestraFechaCamara"
              [class.perfil-field--invalid]="isInvalid('fechaRegistroCamara')">
              <div class="perfil-field__label-with-hint">
                <label class="perfil-field__label" for="fechaRegistroCamara">{{
                  copy.sobreEmpresa.campos.fechaRegistroCamara
                  }}</label>
                @if (mensajeFechaRegistro) {
                <button type="button" class="perfil-field__hint" [attr.aria-label]="mensajeFechaRegistro"
                  [attr.aria-describedby]="'tooltip-fecha-camara'" [attr.aria-expanded]="fechaCamaraHintOpen"
                  (mouseenter)="showFechaCamaraHint($event)" (mouseleave)="hideFechaCamaraHint()"
                  (focus)="showFechaCamaraHint($event)" (blur)="hideFechaCamaraHint()">
                  <span class="material-icons perfil-field__hint-icon" aria-hidden="true">help_outline</span>
                  <span id="tooltip-fecha-camara" class="perfil-field__tooltip"
                    [class.perfil-field__tooltip--open]="fechaCamaraHintOpen"
                    [style.top]="fechaCamaraHintStyle['top']" [style.left]="fechaCamaraHintStyle['left']"
                    role="tooltip">
                    {{ mensajeFechaRegistro }}
                  </span>
                </button>
                }
              </div>
              <input id="fechaRegistroCamara" class="perfil-field__control" type="date"
                formControlName="fechaRegistroCamara" [attr.placeholder]="copy.sobreEmpresa.placeholderFecha"
                [attr.max]="fechaActual" min="1900-01-01" [attr.title]="mensajeFechaRegistro"
                [class.perfil-field__control--invalid]="isInvalid('fechaRegistroCamara')" />
              @if (isInvalid('fechaRegistroCamara')) {
              <p class="perfil-field__error">{{ errorMessage('fechaRegistroCamara') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('departamento')">
              <label class="perfil-field__label" for="departamento">{{
                copy.sobreEmpresa.campos.departamento
                }}</label>
              <select id="departamento" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona departamento"
                formControlName="departamento" (change)="onDepartamentoChange($event)"
                [class.perfil-field__control--invalid]="isInvalid('departamento')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreEmpresa.placeholderSelect }}</option>
                @for (opt of departamentos; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('departamento')) {
              <p class="perfil-field__error">{{ errorMessage('departamento') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('ciudad')">
              <label class="perfil-field__label" for="ciudad">{{ copy.sobreEmpresa.campos.ciudad }}</label>
              <select id="ciudad" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona ciudad"
                formControlName="ciudad" (change)="onCiudadChange()"
                [class.perfil-field__control--invalid]="isInvalid('ciudad')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreEmpresa.placeholderSelect }}</option>
                @for (opt of ciudades; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('ciudad')) {
              <p class="perfil-field__error">{{ errorMessage('ciudad') }}</p>
              }
            </div>

            @if (muestraLocalidad) {
            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('localidad')">
              <label class="perfil-field__label" for="localidad">{{
                copy.sobreEmpresa.campos.localidad
                }}</label>
              <select id="localidad" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona localidad"
                formControlName="localidad" (change)="onLocalidadChange()"
                [class.perfil-field__control--invalid]="isInvalid('localidad')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreEmpresa.placeholderSelect }}</option>
                @for (opt of localidades; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('localidad')) {
              <p class="perfil-field__error">{{ errorMessage('localidad') }}</p>
              }
            </div>
            }

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('barrio')">
              <label class="perfil-field__label" for="barrio">{{ copy.sobreEmpresa.campos.barrio }}</label>
              <input id="barrio" class="perfil-field__control" type="text" formControlName="barrio"
                [placeholder]="copy.sobreEmpresa.placeholderTexto"
                [class.perfil-field__control--invalid]="isInvalid('barrio')" />
              @if (isInvalid('barrio')) {
              <p class="perfil-field__error">{{ errorMessage('barrio') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('direccion')">
              <label class="perfil-field__label" for="direccion">{{
                copy.sobreEmpresa.campos.direccion
                }}</label>
              <input id="direccion" class="perfil-field__control" type="text" formControlName="direccion"
                [placeholder]="copy.sobreEmpresa.placeholderTexto"
                [class.perfil-field__control--invalid]="isInvalid('direccion')" />
              @if (isInvalid('direccion')) {
              <p class="perfil-field__error">{{ errorMessage('direccion') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('tipoSociedad')">
              <label class="perfil-field__label" for="tipoSociedad">{{
                copy.sobreEmpresa.campos.tipoSociedad
                }}</label>
              <select id="tipoSociedad" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona tipo de sociedad"
                formControlName="tipoSociedad" (change)="onTipoSociedadChange()"
                [class.perfil-field__control--invalid]="isInvalid('tipoSociedad')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreEmpresa.placeholderSelect }}</option>
                @for (opt of tiposSociedad; track opt.id) {
                <option [value]="'' + opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('tipoSociedad')) {
              <p class="perfil-field__error">{{ errorMessage('tipoSociedad') }}</p>
              }
            </div>
          </div>
          }

          @if (currentStepId === 'fotos') {
          <div class="perfil-empresa-docs-fotos">
          @if (documentosSeccion.length) {
          <div class="perfil-empresa-docs" id="perfil-sobre-ti-docs">
            @for (doc of documentosSeccion; track doc.valueKey) {
            <div class="perfil-cedula" [class.perfil-cedula--invalid]="isInvalid(doc.valueKey)"
              [class.perfil-cedula--loaded]="hasDoc(doc.valueKey)"
              [class.perfil-cedula--multi]="doc.multiple">
              <div class="perfil-cedula__header">
                <div class="perfil-cedula__text">
                  <p class="perfil-cedula__title" [class.perfil-field--required]="doc.obligatorio">
                    <span class="perfil-field__label">{{ labelDoc(doc) }}</span>
                  </p>
                  @if (doc.descripcion) {
                  <p class="perfil-cedula__hint">{{ doc.descripcion }}</p>
                  }
                  @if (isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)) {
                  <p class="perfil-field__error">{{ errorMessage(doc.valueKey) }}</p>
                  }
                </div>
                <div class="perfil-cedula__slots" [class.perfil-cedula__slots--multi]="isDocMultiple(doc)">
                  @if (isDocMultiple(doc)) {
                  <div class="perfil-cedula__multi-head">
                    <span class="perfil-cedula__multi-hint">{{ multiUploadHint(doc) }}</span>
                    <span class="perfil-cedula__multi-count">{{ filledSlotsCount(doc) }} de {{ maxSlotsCount(doc) }}</span>
                  </div>
                  @for (slot of filledSlots(doc); track slot.slotKey) {
                  <div class="perfil-cedula__file-card" role="status"
                    [class.perfil-cedula__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                    [class.perfil-cedula__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                    [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreEmpresa.validaciones.documentosInconsistentes) : ''"
                    container="body">
                    <img class="perfil-cedula__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                    <div class="perfil-cedula__file-meta">
                      <p class="perfil-cedula__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                      <p class="perfil-cedula__file-status">
                        <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                        <span aria-hidden="true"> • </span>
                        <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                      </p>
                    </div>
                    @if (canRemoveSlot(slot.slotKey)) {
                    <button type="button" class="perfil-cedula__file-remove"
                      [attr.aria-label]="copy.sobreTi.cedulaArchivoQuitar" (click)="removeDoc(slot.slotKey)">
                      <span class="material-icons" aria-hidden="true">close</span>
                    </button>
                    }
                  </div>
                  }
                  @if (nextEmptySlot(doc); as next) {
                  <div class="perfil-cedula__slot">
                    <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(next.slotKey, $event)" />
                    <button type="button" class="perfil-btn perfil-btn--upload"
                      [attr.id]="'btn-perfil-sobre-ti-' + next.slotKey"
                      (click)="onDocCargarClick(doc, next.slotKey, docInput)">
                      <span>{{ multiUploadCta(doc) }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                  </div>
                  }
                  } @else {
                  @for (slot of slotsFor(doc); track slot.slotKey) {
                  <div class="perfil-cedula__slot">
                    <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(slot.slotKey, $event)" />
                    @if (!hasSlotDoc(slot.slotKey)) {
                    <button type="button" class="perfil-btn perfil-btn--upload"
                      [attr.id]="'btn-perfil-sobre-ti-' + slot.slotKey"
                      (click)="onDocCargarClick(doc, slot.slotKey, docInput)">
                      <span>{{ copy.sobreTi.cedulaCta }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                    } @else {
                    <div class="perfil-cedula__file-card" role="status"
                      [class.perfil-cedula__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                      [class.perfil-cedula__file-card--approved]="isSlotAprobadoUi(slot.slotKey)">
                      <img class="perfil-cedula__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                      <div class="perfil-cedula__file-meta">
                        <p class="perfil-cedula__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                        <p class="perfil-cedula__file-status">
                          <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                          <span aria-hidden="true"> • </span>
                          <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                        </p>
                      </div>
                      @if (canRemoveSlot(slot.slotKey)) {
                      <button type="button" class="perfil-cedula__file-remove"
                        [attr.aria-label]="copy.sobreTi.cedulaArchivoQuitar"
                        (click)="removeDoc(slot.slotKey, docInput)">
                        <span class="material-icons" aria-hidden="true">close</span>
                      </button>
                      }
                    </div>
                    }
                  </div>
                  }
                  }
                </div>
              </div>
            </div>
            }
          </div>
          }

          @if (fotoDocs.length) {
          <div class="perfil-fotos">
            <div class="perfil-fotos__intro">
              <h2 class="perfil-fotos__title perfil-field--required">
                <span class="perfil-field__label">{{ copy.sobreNegocio.fotosHeading }}</span>
              </h2>
              <p class="perfil-fotos__hint">{{ copy.sobreNegocio.fotosHint }}</p>
            </div>
            <div class="perfil-fotos__list">
              @for (doc of fotoDocs; track doc.valueKey; let i = $index) {
              <div class="perfil-fotos__row" [class.perfil-fotos__row--loaded]="hasFotoLoaded(i)"
                [class.perfil-fotos__row--invalid]="isInvalid(doc.valueKey) && !hasFoto(i)"
                [class.perfil-fotos__row--rejected]="isFotoRechazada(i)"
                [class.perfil-fotos__row--approved]="isFotoAprobadaUi(i)">
                <p class="perfil-fotos__label">{{ i + 1 }}. {{ labelDoc(doc) }}</p>
                <input #fotoInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                  [attr.aria-label]="doc.label" (change)="onFotoSelected(i, $event)" />
                @if (!hasFotoLoaded(i)) {
                <button type="button" class="perfil-btn perfil-btn--upload perfil-fotos__upload-btn"
                  [attr.id]="'btn-perfil-foto-' + doc.valueKey" (click)="onFotoCargarClick(i)">
                  <span class="perfil-fotos__cta-desktop">{{ copy.sobreNegocio.fotosCta }}</span>
                  <span class="perfil-fotos__cta-mobile">{{ copy.sobreNegocio.fotosCtaMobile }}</span>
                  <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                </button>
                } @else {
                <div class="perfil-fotos__file-card" role="status"
                  [class.perfil-fotos__file-card--rejected]="isFotoRechazada(i)"
                  [class.perfil-fotos__file-card--approved]="isFotoAprobadaUi(i)"
                  [ngbTooltip]="isFotoRechazada(i) ? (fotoObservacion(i) || copy.sobreEmpresa.validaciones.documentosInconsistentes) : ''"
                  container="body">
                  <div class="perfil-fotos__file-icon-wrap">
                    <img class="perfil-fotos__file-icon" [src]="fotoArchivoIcon" alt="" width="24" height="24" />
                  </div>
                  <div class="perfil-fotos__file-meta">
                    <p class="perfil-fotos__file-name">{{ fotos[i].name }}</p>
                    <p class="perfil-fotos__file-status">
                      <span>{{ fotos[i].sizeLabel }}</span>
                      <span aria-hidden="true"> • </span>
                      <span>{{ fotoStatusLabel(i) }}</span>
                    </p>
                  </div>
                  @if (canRemoveFoto(i)) {
                  <button type="button" class="perfil-fotos__file-remove"
                    [attr.aria-label]="copy.sobreNegocio.fotosArchivoQuitar" (click)="removeFoto(i)">
                    <span class="material-icons" aria-hidden="true">close</span>
                  </button>
                  }
                </div>
                }
                @if (isInvalid(doc.valueKey) && !hasFoto(i)) {
                <p class="perfil-field__error perfil-fotos__error">{{ errorMessage(doc.valueKey) }}</p>
                }
              </div>
              }
            </div>
          </div>
          } @else if (esJuridica) {
          <div class="perfil-fotos">
            <div class="perfil-fotos__intro">
              <h2 class="perfil-fotos__title perfil-field--required">
                <span class="perfil-field__label">{{ copy.sobreNegocio.fotosHeading }}</span>
              </h2>
              <p class="perfil-fotos__hint">{{ copy.sobreNegocio.fotosHint }}</p>
            </div>
          </div>
          }
          </div>
          }

          @if (currentStepId === 'info-adicional') {
          <div class="perfil-opcionales">
            <div class="perfil-opcionales__intro">
              <h2 class="perfil-opcionales__title">{{ copy.sobreNegocio.docsOpcionalesHeading }}</h2>
              <p class="perfil-opcionales__hint">{{ copy.sobreNegocio.docsOpcionalesHint }}</p>
            </div>
            <div class="perfil-opcionales__docs">
              @for (doc of documentosInfoAdicional; track doc.valueKey) {
              <div class="perfil-opcionales__doc" [class.perfil-opcionales__doc--loaded]="hasDoc(doc.valueKey)"
                [class.perfil-opcionales__doc--multi]="doc.multiple">
                <div class="perfil-opcionales__doc-text">
                  <p class="perfil-opcionales__doc-title">{{ labelDoc(doc) }}</p>
                  @if (doc.descripcion) {
                  <p class="perfil-opcionales__doc-desc">{{ doc.descripcion }}</p>
                  }
                </div>
                <div class="perfil-opcionales__doc-slots"
                  [class.perfil-opcionales__doc-slots--multi]="isDocMultiple(doc)">
                  @if (isDocMultiple(doc)) {
                  <div class="perfil-opcionales__doc-multi-head">
                    <span class="perfil-opcionales__doc-multi-hint">{{ multiUploadHint(doc) }}</span>
                    <span class="perfil-opcionales__doc-multi-count">{{ filledSlotsCount(doc) }} de {{ maxSlotsCount(doc) }}</span>
                  </div>
                  @for (slot of filledSlots(doc); track slot.slotKey) {
                  <div class="perfil-fotos__file-card perfil-opcionales__file-card" role="status">
                    <div class="perfil-fotos__file-icon-wrap">
                      <img class="perfil-fotos__file-icon" [src]="fotoArchivoIcon" alt="" width="24" height="24" />
                    </div>
                    <div class="perfil-fotos__file-meta">
                      <p class="perfil-fotos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                      <p class="perfil-fotos__file-status">
                        <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                        <span aria-hidden="true"> • </span>
                        <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                      </p>
                    </div>
                    @if (canRemoveSlot(slot.slotKey)) {
                    <button type="button" class="perfil-fotos__file-remove"
                      [attr.aria-label]="copy.sobreNegocio.fotosArchivoQuitar" (click)="removeDoc(slot.slotKey)">
                      <span class="material-icons" aria-hidden="true">close</span>
                    </button>
                    }
                  </div>
                  }
                  @if (nextEmptySlot(doc); as next) {
                  <div class="perfil-opcionales__doc-slot">
                    <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(next.slotKey, $event)" />
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-opcionales__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + next.slotKey"
                      (click)="onDocCargarClick(doc, next.slotKey, docInput)">
                      <span>{{ multiUploadCta(doc) }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                  </div>
                  }
                  } @else {
                  @for (slot of slotsFor(doc); track slot.slotKey) {
                  <div class="perfil-opcionales__doc-slot">
                    <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                      [attr.aria-label]="doc.label" (change)="onDocSelected(slot.slotKey, $event)" />
                    @if (!hasSlotDoc(slot.slotKey)) {
                    <button type="button" class="perfil-btn perfil-btn--upload perfil-opcionales__upload-btn"
                      [attr.id]="'btn-perfil-doc-' + slot.slotKey"
                      (click)="onDocCargarClick(doc, slot.slotKey, docInput)">
                      <span>{{ copy.sobreTi.cedulaCta }}</span>
                      <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                    </button>
                    } @else {
                    <div class="perfil-fotos__file-card perfil-opcionales__file-card" role="status">
                      <div class="perfil-fotos__file-icon-wrap">
                        <img class="perfil-fotos__file-icon" [src]="fotoArchivoIcon" alt="" width="24" height="24" />
                      </div>
                      <div class="perfil-fotos__file-meta">
                        <p class="perfil-fotos__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                        <p class="perfil-fotos__file-status">
                          <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                          <span aria-hidden="true"> • </span>
                          <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                        </p>
                      </div>
                      @if (canRemoveSlot(slot.slotKey)) {
                      <button type="button" class="perfil-fotos__file-remove"
                        [attr.aria-label]="copy.sobreNegocio.fotosArchivoQuitar"
                        (click)="removeDoc(slot.slotKey, docInput)">
                        <span class="material-icons" aria-hidden="true">close</span>
                      </button>
                      }
                    </div>
                    }
                  </div>
                  }
                  }
                </div>
              </div>
              }
            </div>

            <div class="perfil-opcionales__redes">
              <div class="perfil-opcionales__redes-intro">
                <h3 class="perfil-opcionales__redes-title">{{ copy.sobreNegocio.redesHeading }}</h3>
                <p class="perfil-opcionales__hint">{{ copy.sobreNegocio.redesHint }}</p>
              </div>
              <div class="perfil-opcionales__redes-list">
                @for (red of redesItems; track red.id) {
                <div class="perfil-opcionales__red">
                  <label class="perfil-opcionales__check-row">
                    <input class="perfil-opcionales__check-input" type="checkbox" [formControlName]="red.id" />
                    <span class="perfil-opcionales__check" aria-hidden="true">
                      <img class="perfil-opcionales__check-icon" [src]="checkIcon" alt="" width="12" height="9" />
                    </span>
                    <span class="perfil-opcionales__check-label">{{ red.label }}</span>
                  </label>
                  @if (isRedChecked(red.id)) {
                  <div class="perfil-opcionales__url-wrap" [class.perfil-field--invalid]="isInvalid(red.id + 'Url')">
                    <input class="perfil-field__control perfil-opcionales__url" type="url"
                      [formControlName]="red.id + 'Url'" [placeholder]="copy.sobreNegocio.placeholderUrl"
                      [attr.aria-label]="'URL de ' + red.label"
                      [class.perfil-field__control--invalid]="isInvalid(red.id + 'Url')" />
                    @if (isInvalid(red.id + 'Url')) {
                    <p class="perfil-field__error">{{ errorMessage(red.id + 'Url') }}</p>
                    }
                  </div>
                  }
                </div>
                }
              </div>
            </div>
          </div>
          }
          } @else {
          <!-- PN: un solo scroll (sin multi-paso) -->
          <div class="perfil-section-page__grid" id="perfil-sobre-ti-datos">
            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('genero')">
              <label class="perfil-field__label" for="genero">{{ copy.sobreTi.campos.genero }}</label>
              <select id="genero" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona género"
                formControlName="genero" (change)="onSelectpickerChange('genero')"
                [class.perfil-field__control--invalid]="isInvalid('genero')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreTi.placeholderSelect }}</option>
                @for (opt of generos; track opt.id) {
                <option [value]="opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('genero')) {
              <p class="perfil-field__error">{{ errorMessage('genero') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('fechaNacimiento')">
              <label class="perfil-field__label" for="fechaNacimiento">{{
                copy.sobreTi.campos.fechaNacimiento
                }}</label>
              <input id="fechaNacimiento" class="perfil-field__control" type="date" [attr.min]="fechaNacMin"
                [attr.max]="fechaNacMax" [attr.placeholder]="copy.sobreTi.placeholderFecha"
                formControlName="fechaNacimiento" [class.perfil-field__control--invalid]="isInvalid('fechaNacimiento')"
                (change)="onFechaNacimientoChange()" />
              @if (isInvalid('fechaNacimiento')) {
              <p class="perfil-field__error">{{ errorMessage('fechaNacimiento') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('fechaExpedicion')">
              <label class="perfil-field__label" for="fechaExpedicion">{{
                copy.sobreTi.campos.fechaExpedicion
                }}</label>
              <input id="fechaExpedicion" class="perfil-field__control" type="date" [attr.max]="fechaExpMax"
                [attr.placeholder]="copy.sobreTi.placeholderFecha" formControlName="fechaExpedicion"
                [class.perfil-field__control--invalid]="isInvalid('fechaExpedicion')"
                (change)="onFechaExpedicionChange()" (blur)="onFechaExpedicionBlur()" />
              @if (isInvalid('fechaExpedicion')) {
              <p class="perfil-field__error">{{ errorMessage('fechaExpedicion') }}</p>
              }
            </div>
          </div>

          @for (doc of documentosSeccion; track doc.valueKey) {
          <div class="perfil-cedula" [class.perfil-cedula--invalid]="isInvalid(doc.valueKey)"
            [class.perfil-cedula--loaded]="hasDoc(doc.valueKey)"
            [class.perfil-cedula--multi]="doc.multiple"
            [attr.id]="$first ? 'perfil-sobre-ti-docs' : null">
            <div class="perfil-cedula__header">
              <div class="perfil-cedula__text">
                <p class="perfil-cedula__title" [class.perfil-field--required]="doc.obligatorio">
                  <span class="perfil-field__label">{{ labelDoc(doc) }}</span>
                </p>
                @if (doc.descripcion) {
                <p class="perfil-cedula__hint">{{ doc.descripcion }}</p>
                }
                @if (isInvalid(doc.valueKey) && !hasDoc(doc.valueKey)) {
                <p class="perfil-field__error">{{ errorMessage(doc.valueKey) }}</p>
                }
              </div>
              <div class="perfil-cedula__slots"
                [class.perfil-cedula__slots--multi]="isDocMultiple(doc)">
                @if (isDocMultiple(doc)) {
                <div class="perfil-cedula__multi-head">
                  <span class="perfil-cedula__multi-hint">{{ multiUploadHint(doc) }}</span>
                  <span class="perfil-cedula__multi-count">{{ filledSlotsCount(doc) }} de {{ maxSlotsCount(doc) }}</span>
                </div>

                @for (slot of filledSlots(doc); track slot.slotKey) {
                <div class="perfil-cedula__file-card" role="status"
                  [class.perfil-cedula__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                  [class.perfil-cedula__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                  [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreTi.validaciones.documentosInconsistentes) : ''"
                  container="body">
                  <img class="perfil-cedula__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                  <div class="perfil-cedula__file-meta">
                    <p class="perfil-cedula__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                    <p class="perfil-cedula__file-status">
                      <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                      <span aria-hidden="true"> • </span>
                      <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                    </p>
                    @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                    <p class="perfil-cedula__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                    }
                  </div>
                  @if (canRemoveSlot(slot.slotKey)) {
                  <button type="button" class="perfil-cedula__file-remove"
                    [attr.aria-label]="copy.sobreTi.cedulaArchivoQuitar"
                    (click)="removeDoc(slot.slotKey)">
                    <span class="material-icons" aria-hidden="true">close</span>
                  </button>
                  }
                </div>
                }

                @if (nextEmptySlot(doc); as next) {
                <div class="perfil-cedula__slot">
                  <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                    [attr.aria-label]="doc.label" (change)="onDocSelected(next.slotKey, $event)" />
                  <button type="button" class="perfil-btn perfil-btn--upload"
                    [attr.id]="'btn-perfil-sobre-ti-' + next.slotKey"
                    (click)="openDocModal(doc, next.slotKey, docInput)">
                    <span>{{ multiUploadCta(doc) }}</span>
                    <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                  </button>
                </div>
                }
                } @else {
                @for (slot of slotsFor(doc); track slot.slotKey) {
                <div class="perfil-cedula__slot">
                  <input #docInput class="perfil-cedula__input" type="file" [accept]="acceptFor(doc)"
                    [attr.aria-label]="doc.label" (change)="onDocSelected(slot.slotKey, $event)" />

                  @if (!hasSlotDoc(slot.slotKey)) {
                  <button type="button" class="perfil-btn perfil-btn--upload"
                    [attr.id]="'btn-perfil-sobre-ti-' + slot.slotKey"
                    (click)="openDocModal(doc, slot.slotKey, docInput)">
                    <span>{{ copy.sobreTi.cedulaCta }}</span>
                    <span class="material-icons perfil-btn__upload-icon" aria-hidden="true">upload</span>
                  </button>
                  } @else {
                  <div class="perfil-cedula__file-card" role="status"
                    [class.perfil-cedula__file-card--rejected]="isSlotRechazado(slot.slotKey)"
                    [class.perfil-cedula__file-card--approved]="isSlotAprobadoUi(slot.slotKey)"
                    [ngbTooltip]="isSlotRechazado(slot.slotKey) ? (slotObservacion(slot.slotKey) || copy.sobreTi.validaciones.documentosInconsistentes) : ''"
                    container="body">
                    <img class="perfil-cedula__file-icon" [src]="archivoIcon" alt="" width="24" height="24" />
                    <div class="perfil-cedula__file-meta">
                      <p class="perfil-cedula__file-name">{{ docsFiles[slot.slotKey].name }}</p>
                      <p class="perfil-cedula__file-status">
                        <span>{{ docsFiles[slot.slotKey].sizeLabel }}</span>
                        <span aria-hidden="true"> • </span>
                        <span>{{ slotStatusLabel(slot.slotKey) }}</span>
                      </p>
                      @if (isSlotRechazado(slot.slotKey) && slotObservacion(slot.slotKey)) {
                      <p class="perfil-cedula__file-obs">{{ slotObservacion(slot.slotKey) }}</p>
                      }
                    </div>
                    @if (canRemoveSlot(slot.slotKey)) {
                    <button type="button" class="perfil-cedula__file-remove"
                      [attr.aria-label]="copy.sobreTi.cedulaArchivoQuitar"
                      (click)="removeDoc(slot.slotKey, docInput)">
                      <span class="material-icons" aria-hidden="true">close</span>
                    </button>
                    }
                  </div>
                  }
                </div>
                }
                }
              </div>
            </div>
          </div>
          }

          <div class="perfil-section-page__grid">
            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('estadoCivil')">
              <label class="perfil-field__label" for="estadoCivil">{{
                copy.sobreTi.campos.estadoCivil
                }}</label>
              <select id="estadoCivil" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona estado civil"
                formControlName="estadoCivil" (change)="onSelectpickerChange('estadoCivil')"
                [class.perfil-field__control--invalid]="isInvalid('estadoCivil')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreTi.placeholderSelect }}</option>
                @for (opt of estadosCivil; track opt.id) {
                <option [value]="opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('estadoCivil')) {
              <p class="perfil-field__error">{{ errorMessage('estadoCivil') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('nivelEstudios')">
              <label class="perfil-field__label" for="nivelEstudios">{{
                copy.sobreTi.campos.nivelEstudios
                }}</label>
              <select id="nivelEstudios" class="form-control selectpicker perfil-field__control"
                data-live-search="true" data-width="100%" data-size="5" title="Selecciona nivel de estudios"
                formControlName="nivelEstudios" (change)="onSelectpickerChange('nivelEstudios')"
                [class.perfil-field__control--invalid]="isInvalid('nivelEstudios')">
                <option [value]="''" class="option-placeholder">{{ copy.sobreTi.placeholderSelect }}</option>
                @for (opt of nivelesEstudios; track opt.id) {
                <option [value]="opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('nivelEstudios')) {
              <p class="perfil-field__error">{{ errorMessage('nivelEstudios') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('personasACargo')">
              <label class="perfil-field__label" for="personasACargo">{{
                copy.sobreTi.campos.personasACargo
                }}</label>
              <select id="personasACargo" class="perfil-field__control" formControlName="personasACargo"
                [class.perfil-field__control--invalid]="isInvalid('personasACargo')">
                <option value="">{{ copy.sobreTi.placeholderSelect }}</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5 o más</option>
              </select>
              @if (isInvalid('personasACargo')) {
              <p class="perfil-field__error">{{ errorMessage('personasACargo') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('seguridadSocial')">
              <span class="perfil-field__label" id="lbl-seguridad">{{
                copy.sobreTi.campos.seguridadSocial
                }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-seguridad">
                <label class="perfil-radio">
                  <input type="radio" formControlName="seguridadSocial" value="si" />
                  <span>{{ copy.sobreTi.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="seguridadSocial" value="no" />
                  <span>{{ copy.sobreTi.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('seguridadSocial')) {
              <p class="perfil-field__error">{{ errorMessage('seguridadSocial') }}</p>
              }
            </div>

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('sisben')">
              <span class="perfil-field__label" id="lbl-sisben">{{ copy.sobreTi.campos.sisben }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-sisben">
                <label class="perfil-radio">
                  <input type="radio" formControlName="sisben" value="si" />
                  <span>{{ copy.sobreTi.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="sisben" value="no" />
                  <span>{{ copy.sobreTi.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('sisben')) {
              <p class="perfil-field__error">{{ errorMessage('sisben') }}</p>
              }
            </div>

            @if (muestraGrupoSisben) {
            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('idSisben')">
              <label class="perfil-field__label" for="idSisben">{{ copy.sobreTi.campos.gruposSisben }}</label>
              <select id="idSisben" class="perfil-field__control" formControlName="idSisben"
                [class.perfil-field__control--invalid]="isInvalid('idSisben')">
                <option value="">{{ copy.sobreTi.placeholderSelect }}</option>
                @for (opt of gruposSisben; track opt.id) {
                <option [value]="opt.id">{{ opt.nombre }}</option>
                }
              </select>
              @if (isInvalid('idSisben')) {
              <p class="perfil-field__error">{{ errorMessage('idSisben') }}</p>
              }
            </div>
            }

            <div class="perfil-field perfil-field--required" [class.perfil-field--invalid]="isInvalid('creditoFormal')">
              <span class="perfil-field__label" id="lbl-credito">{{
                copy.sobreTi.campos.creditoFormal
                }}</span>
              <div class="perfil-radio-group" role="radiogroup" aria-labelledby="lbl-credito">
                <label class="perfil-radio">
                  <input type="radio" formControlName="creditoFormal" value="si" />
                  <span>{{ copy.sobreTi.campos.si }}</span>
                </label>
                <label class="perfil-radio">
                  <input type="radio" formControlName="creditoFormal" value="no" />
                  <span>{{ copy.sobreTi.campos.no }}</span>
                </label>
              </div>
              @if (isInvalid('creditoFormal')) {
              <p class="perfil-field__error">{{ errorMessage('creditoFormal') }}</p>
              }
            </div>

            @if (muestraFechaDesembolso) {
            <div class="perfil-field perfil-field--required"
              [class.perfil-field--invalid]="isInvalid('fechaDesembolso')">
              <label class="perfil-field__label" for="fechaDesembolso">{{
                copy.sobreTi.campos.fechaDesembolso
                }}</label>
              <input id="fechaDesembolso" class="perfil-field__control" type="date" [attr.max]="fechaDesembolsoMax"
                min="1900-01-01" formControlName="fechaDesembolso"
                [class.perfil-field__control--invalid]="isInvalid('fechaDesembolso')" />
              @if (isInvalid('fechaDesembolso')) {
              <p class="perfil-field__error">{{ errorMessage('fechaDesembolso') }}</p>
              }
            </div>
            }
          </div>
          }
        </form>
      </div>
    </div>
  </div>

  <app-perfil-section-footer perfilSectionFooter variant="necesidad" seccionId="sobre-ti" [showSaltar]="showSaltar"
    [ctaLabelOverride]="ctaLabel" [continuarDisabled]="continuarDisabled" (saltar)="onSaltar()"
    (continuar)="onCta()"></app-perfil-section-footer>
</app-perfil-shell>

<app-perfil-documento-modal [open]="docModalOpen" [config]="docModalConfig" (closed)="closeDocModal()"
  (subir)="onSubirDesdeModal()"></app-perfil-documento-modal>

@if (esJuridica) {
<app-perfil-intro-modal [open]="introModalOpen" seccionId="sobre-ti" [juridica]="true" (closed)="closeIntroModal()"
  (completarDatos)="onIntroCompletarDatos()"></app-perfil-intro-modal>
}

<app-perfil-salir-modal [open]="salirModalOpen" (closed)="closeSalirModal()"
  (guardar)="onSalirGuardar()"></app-perfil-salir-modal>
